<template>
  <form @submit.prevent="handleSubmit">
    <h2 class="-mt-6 mb-6">Acompte pour le devis: DV-{{ doc_number }}</h2>
    <div class="flex flex-col gap-4">
      <div class="max-w-md">
        <label for="price" class="block text-sm font-medium text-gray-700"> Acompte (HTVA) </label>
        <input
          disabled
          :value="price_excl"
          @input="setPriceExcl($event.target.value)"
          type="text"
          name="price"
          id="price"
          class="block w-full sm:text-sm shadow-sm focus:ring-indigo-500 focus:border-indigo-500 border rounded-md border-gray-200"
        />
      </div>
      <div class="max-w-md">
        <label for="vat" class="block text-sm font-medium text-gray-700"> TVA </label>
        <select
          v-model="vat"
          name="vat"
          id="vat"
          :disabled="loading"
          class="p-2 block w-full sm:text-sm shadow-sm focus:ring-indigo-500 focus:border-indigo-500 border rounded-md border-gray-200"
        >
          <option value="0">0%</option>
          <option value="6">6%</option>
          <option value="12">12%</option>
          <option value="21">21%</option>
        </select>
      </div>
      <div class="max-w-md">
        <label for="price" class="block text-sm font-medium text-gray-700"> Acompte (TVAC) </label>
        <input
          :value="price_incl"
          @input="setPriceInc($event.target.value)"
          type="text"
          name="price"
          id="price"
          :disabled="loading"
          class="block w-full sm:text-sm shadow-sm focus:ring-indigo-500 focus:border-indigo-500 border rounded-md border-gray-200"
        />
      </div>
    </div>
    <div class="pt-5">
      <small>Le client vous donne {{ price_incl }} EUR. d'acompte</small>
      <div class="flex">
        <button
          :disabled="loading || disabled"
          type="submit"
          :class="{ 'hover:bg-indigo-700': !(loading || disabled) }"
          class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >
          <i v-if="loading" class="fas fa-spinner mt-1"></i>
          <span v-else>Creer facture d'acompte</span>
        </button>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  theme() {
    return {
      title: `Ajouter une facture d'acompte`,
      subtitle: '',
    }
  },
}
</script>

<script setup>
import { defineProps, ref, computed } from 'vue'
import { useRouter } from 'vue-router'
// import clone from 'just-clone'
import useApi from '@/hooks/useApi'

const props = defineProps({
  doc_number: String,
})

const price_excl = ref(0)
const price_incl = ref(0)
const vat = ref(21)
const loading = ref(false)

const api = useApi()
const router = useRouter()

const handleSubmit = () => {
  const postData = {
    doc_number: props.doc_number,
    price_excl: price_excl.value,
    price_incl: price_incl.value,
    vat: vat.value,
  }

  api.quotes.toAcompte(postData).then(({ data }) => {
    // console.log({ data })
    router.push(`/invoices`)
  })
}

const disabled = computed(() => price_excl.value <= 0 || price_incl.value <= 0)
const factor = computed(() => 1 + vat.value / 100)

const setPriceInc = val => {
  if (val % 1) {
    return setPriceInc(String(val).split('.')[0].split(',')[0])
  }
  if (val == price_incl.value) return
  if (val <= 0) {
    price_excl.value = 0
  } else {
    price_excl.value = Number((val / factor.value).toFixed(2))
  }
  price_incl.value = val
}

const setPriceExcl = val => {
  if (val == price_excl.value) return
  if (val <= 0) {
    price_incl.value = 0
  } else {
    price_incl.value = Number((val * factor.value).toFixed(2))
  }
  price_excl.value = val
}
</script>
